module.exports = __webpack_public_path__ + "img/img／人气爆款.03a1f08a.png";